import { Link } from "react-router-dom";

export default function HeaderBack({
  text,
  url,
  replace = false,
}: {
  text: string;
  url: string;
  replace?: boolean;
}) {
  return (
    <div className="relative flex items-center justify-center py-4">
      {/* Tombol Back di kiri */}
      <div className="absolute left-0 ml-5 transform -translate-y-1/2 top-1/2">
        <Link
          to={url}
          replace={replace}
          className=" inline-flex items-center text-[#1e1e1e] hover:text-[#37393d] transition-colors group"
        >
          <svg
            className="w-5 h-5 mr-1 lg:mr-2"
            fill="none"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path d="M15 19l-7-7 7-7" className="dark:text-white"></path>
          </svg>
          <span className=" dark:text-white lg:text-lg font-medium underline decoration-wavy underline-offset-4 decoration-[#1e1e1e] group-hover:decoration-[#37393d] transition-colors dark:decoration-primary">
            Back
          </span>
        </Link>
      </div>

      {/* Judul di tengah */}
      <h1 className="text-xl lg:text-xl font-medium text-center text-[#1e1e1e] dark:text-white">
        {text}
      </h1>
    </div>
  );
}
